import React, { useState } from 'react';
import { Toast } from '@mds/mds-reactjs-library';
import PropTypes from 'prop-types';
import { IA_CUSTOM_ERROR } from '../../containers/Inclusion/constants';
import { getStaticText } from '../../utils/constants';

import './index.scss';

export default function ErrorToast({ message, showHeaderMessage = true }) {
    const [open, setOpen] = useState(true);
    const staticText = getStaticText();
    const { SITE_TEXT } = staticText;
    const { ERROR } = SITE_TEXT;
    const errorMessage = message || IA_CUSTOM_ERROR;

    return open ? (
        <div className="infoToastContainer">
            <Toast type="danger" title="Request processing error" onCloseClick={() => setOpen(false)}>
                {showHeaderMessage ? (
                    <>
                        {errorMessage} <br /> <br />
                    </>
                ) : null}
                <span className="error">
                    {ERROR}: {errorMessage}
                </span>
            </Toast>
        </div>
    ) : null;
}

ErrorToast.propTypes = {
    message: PropTypes.string.isRequired,
    showHeaderMessage: PropTypes.bool,
};

ErrorToast.defaultProps = {
    showHeaderMessage: true,
};
